import api from "../services/api";
import { getToken } from "../utils/storage";

export const listEvents = (queryParams) => {
    return api.get(`company/event/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const getEvent = (queryParams) => {
    return api.get(`/company/event/details${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const createNewEvent = (formData) => {
    return api.post('company/event/add',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
}

export const changeEventStatus = ({ status, event_id }) => {
    return api.put('/company/event/deactivate',
        { status, event_id }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const updateEvent = (formData) => {
    return api.put('company/event/edit',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const deleteEvent = ({ event_id }) => {
    return api.delete('/company/event/delete', {
        data: { event_id },
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

// invitations
export const getEventInvitationList = (queryParams) => {
    return api.get(`/company/event/invitation/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const createNewEventInvitation = (data) => {
    return api.post('company/event/invitation/send',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const cancelEventInvitation = (data) => {
    return api.post('/company/event/invitation/cancel',
        { ...data }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

export const createNewEventInvitationBulk = (formData) => {
    return api.post('company/event/invitation/bulk-send',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getToken()}`
        }
    });
}

// Recording
export const getEventRecordingList = (queryParams) => {
    return api.get(`/company/event/recording/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
        }
    });
}